import * as s from "./OutOfStockLabel.module.scss";

const OutOfStockLabel = ({ label }: { label: string }) => (
	<span className={s.outOfStockLabel}>{label}</span>
);

export default OutOfStockLabel;
